import { ASSISTANT_ERROR_BY_STATUS } from '../constants';

interface TRequestError {
    response?: { status?: number };
}

/**
 * i18n key for a failed assistant request: specific by HTTP status, or the fallback.
 */
export const getRequestErrorKey = (
    requestError: TRequestError,
    fallbackKey: string
): string =>
    ASSISTANT_ERROR_BY_STATUS[requestError?.response?.status] || fallbackKey;
